<div class="header-left">
    <div class="header-action">
        <ng-content />
    </div>
</div>
